<template>
  <div id="brandbar_all" v-if="brandbar_show">
    <!--//@*/*
        //    *BCS   App v0.91
        //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
        //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
        //    */
        //-->
    <!-- app bar container -->
    <v-row>
      <v-col cols="12">
        <div
          id="v-app-bar--container"
          class=""
          style="width: 100%; height: 48px"
        >
          <!-- old height="152px" -->
          <!-- navigation drawer -->
          <v-navigation-drawer
            id="v-navigation-drawer"
            height="63px"
            v-model="drawer"
            temporary
            absolute
            class="drawer_pos mt-8"
          >
            <v-list nav dense close-on-click close-on-content-click>
              <v-list-item-group
                v-model="group"
                active-class="primary white--text"
              >
                <v-list-item @click.prevent="menu_home">
                  <v-list-item-icon>
                    <v-icon color="blue darken-4">$home</v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>Home</v-list-item-title>
                </v-list-item>

                <v-divider></v-divider>
              </v-list-item-group>
            </v-list>
          </v-navigation-drawer>

          <!-- v-app-bar -->
          <!-- absolute -->
          <v-app-bar
            id="appbar"
            fixed
            app
            class="mx-auto white darken-5 d-flex justify-center"
            dense
            style="
              background-color: #002e42 !important;
              color: white !important;
              width: 100%;
              max-width: 768px;
            "
          >
            <!-- nav icon -->
            <!-- align-self-start -->
            <!-- <div class="nav-icon d-flex justify start">
              <v-app-bar-nav-icon
                id="v-app-bar-nav-icon"
                v-show="true"
                x-large
                @click="show_drawer"
              ></v-app-bar-nav-icon>
            </div> -->

            <v-spacer></v-spacer>

            <!--  badge image -->
            <!-- align-self-center -->
            <div class="img-container d-flex justify-center">
              <v-img
                class="flex-grow-0"
                max-width="166"
                height="80%"
                width="166px"
                src="../images/badgesex150_40_3_white.png"
              ></v-img>
            </div>

            <!-- <v-spacer></v-spacer> -->

            <!-- logoff icon -->
            <!-- align-self-end  -->
            <div id="div_logoff" class="d-flex justify-end">
              <v-btn icon text v-show="true" @click="toggle_logoff">
                <v-icon x-large>$person</v-icon>
              </v-btn>
            </div>
          </v-app-bar>
        </div>
      </v-col>
    </v-row>

    <!-- app title container -->
    <div
      id="app-title-container"
      style="width: 100%; height: 48px"
      class="d-flex"
    >
      <v-spacer></v-spacer>
      <div
        id="apptitle"
        style="
          background-color: #002e42 !important;
          color: white !important;
          max-width: 768px;
          width: 100%;
          height: 30px;
          text-align: center;
          vertical-align: middle;
        "
        class="my-2 ml-lg-4"
      >
        <span class="text-h6">{{ app_title }}</span>
      </div>

      <v-spacer></v-spacer>
    </div>

    <!-- logoff -->
    <div
      id="logoff-popup"
      class="text-white"
      @click="logoff"
      style="
        z-index: 500;
        background-color: aliceblue;
        text-decoration: underline;
        cursor: pointer;
        position: absolute;
        top: 40px;
        padding: 10px;
        border-radius: 4px;
        right: 100px;
      "
      v-if="showLogoff"
    >
      Logoff: {{ user_email }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #v-app-bar--container:deep .v-toolbar__content {
    width: 100% !important;
    display: flex !important;
    justify-content: space-between !important;
  }

  .nav-icon,
  .img-container,
  #div_logoff {
    width: 33.3%;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
import { bus_common } from "../mixins/bus_common";
export default {
  name: "brandbar",
  mixins: [bus_common],
  data: function () {
    return {
      brandbar_show: true,
      showLogoff: false,
      user_email: "",
      app_title: "RPD Stats",
      drawer: false,
      group: null,
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      if (this.$store.state.user != "") {
        this.user_email = this.$store.state.user.email;
      } else {
        this.user_email = "UNKNOWN";
      }
    },
    "$store.state.brandbar_show": function () {
      this.brandbar_show = this.$store.state.brandbar_show;
    },
  },
  methods: {
    show_drawer() {
      //   this.mrbreakpoint("go");
      // var bar = document.getElementById("v-app-bar-nav-icon");
      // var rect = bar.getBoundingClientRect();
      // var daDrawer = document.getElementById("v-navigation-drawer");
      // daDrawer.style.left = rect.left + "px";
      // this.drawer = true;
    },
    menu_home() {
      this.$router.push("/?token=" + this.$store.state.user.token);
    },
    menu_help() {
      this.$router.push("/help?token=" + this.$store.state.user.token);
    },
    menu_tsep_admin() {
      this.$router.push("/admin");
    },
    menu_tsep_form() {
      this.$router.push("/tsep_form?token=" + this.$store.state.user.token);
    },
    toggle_logoff() {
      //var bar = document.getElementById("v-app-bar-nav-icon");
      // var rect = bar.getBoundingClientRect();
      this.showLogoff = !this.showLogoff;
      console.log("logoff: " + this.showLogoff);
      // if (this.showLogoff) {
      //   setTimeout(() => {
      //     this.mrbreakpoint("things");
      //     var lg = document.getElementById("logoff-popup");
      //     lg.style.right = rect.right + "px";
      //   }, 200);
      // }
    },
    logoff() {
      window.location.replace("https://rpdportal.org");
    },
  },
};
</script>

<style scoped>
/* .drawer_pos {
  left: 30%;
  top: 150px;
} */

i.v-icon.v-icon {
  color: red;
}

.v-icon {
  color: #ffffff !important;
}
</style>
